import axios from './axios';
import * as login from './customer-api/login';
import * as session from './customer-api/session';
import { G } from './querystring';
import * as toast from './toast';

declare interface credentialResponse {
    credential: string;
}

declare interface myWindow extends Window {
    GoogleCredentialHandler: (response: credentialResponse) => void;
    readonly dashboard: string;
}
declare const window: myWindow;

export function InitGoogleCredentialHandler(returnLoc = G().Get('return')) {
    window.GoogleCredentialHandler = (response: credentialResponse) => {
        axios.post<login.LoginResp>('/sessions', {
            'googleJWT': response.credential,
        }).then(resp => {
            if (resp.data.token) {
                session.SetLoginToken(resp.data.token);
                if (returnLoc) {
                    window.location.href = returnLoc;
                } else {
                    window.location.href = window.dashboard;
                }
                return;
            }

            throw Error('Login failed!');
        }).catch(err => {
            console.error(err);
            toast.Error('There was an error logging you in through Google.');
        });
    };
}
